//MUI
import { Tooltip } from "@mui/material";
import QuestionMarkRoundedIcon from "@mui/icons-material/QuestionMarkRounded";

type TooltipPlacement = "bottom-start" | "bottom-end" | "top-start" | "top-end" | "left-start" | "left-end" | "right-start" | "right-end";

interface HelpTooltipProps {
	title: string;
	placement?: TooltipPlacement;
	maxWidth?: number | string;
	textAlign?: string;
}
function HelpTooltip({ title, placement = "bottom-start", maxWidth = 200, textAlign = "center" }: Readonly<HelpTooltipProps>) {
	return (
		<Tooltip
			title={title}
			arrow
			placement={placement}
			componentsProps={{
				tooltip: {
					sx: {
						fontFamily: "PTSansProNarrow, sans-serif",
						fontSize: 14,
						textAlign,
						maxWidth,
					},
				},
			}}
		>
			<QuestionMarkRoundedIcon color="action" fontSize="small" className="rounded-full border-solid border-2" />
		</Tooltip>
	);
}

export default HelpTooltip;
